<template>
  <app-base-main parentTable>
    <template #filter-group>
      <app-filter-group
          @query="$gjNoticeQuery"
          @reset="$gjReset">
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'code', text: '出入库单号'},
              {id: 'relevanceCode', text: '来源单号'},
            ]"
            :width="['120px', '120px']"
            :placeholder="['', '请输入单号']"
        ></gj-select-input>
        <gj-warehouse-select
            v-model="filter.warehouseIds"
            :fba="false"
            multiple
        ></gj-warehouse-select>
        <gj-select
            v-model="filter.type"
            :options="opTypeOption"
            placeholder="操作类型"
        ></gj-select>
        <gj-creator-select
            v-model="filter.createUser"
        ></gj-creator-select>
        <gj-date-picker
            v-model="filter.date"
            type="daterange"
        ></gj-date-picker>

        <template #right>
          <view-setting
                  :ref="REF_VIEW_SETTING"
                  save-mode="remote"
                  :use-default="true"
                  :module-name="moduleName"
                  :config="model"
                  :fn-generate-params="generateViewParams"
                  @view-change="handleChangeView"
                  @view-complete="handCompleteView"
          >
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button @click="openInboundOutbound(documentTypeEnum.INBOUND)" type="primary" v-if="$permission('inbound:otherInbound')">其他入库</gj-button>
      <gj-button @click="openInboundOutbound(documentTypeEnum.OUTBOUND)" type="primary" v-if="$permission('inbound:otherOutbound')">其他出库</gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group
          :download="$permission('inbound:export')"
          :download-url="`/supply/inbound/export`"
          :download-params="globalParams"
          help
      ></gj-tool-group>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          adaptParent
          :loading="loading"
          :data="tableData"
          :columns="columns"
          :structure-config="{type: 'ParentChild', children: 'items', parentSpan: [0, 8]}"
          :selectable="(row) => row.$gjParentData && !row.$gjExtendRow"
          :extend-row-config="{prop: 'extendRow'}"
          sortable="custom"
          :pagination="pagination"
          :show-overflow="false"
          :default-sort="{prop: 'createTime', order: 'descending'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:picture="{row}">
          <div class="flex" style="flex-wrap:wrap;" v-if="row.$gjParentData">
            <div style="display: inline-block; width: 150px;margin-right: 4px;">
              {{ row.code }}
              <gj-copy-icon :content="row.code"></gj-copy-icon>
            </div>
            <div style="display: inline-block; width: 150px;">
              {{ row.relevanceCode | defaultShow }}
              <gj-copy-icon :content="row.relevanceCode"></gj-copy-icon>
            </div>

            <div class="marginRight40">
              {{ opTypeMap[row.opType].text }}
            </div>
            <div class="marginRight40">
              <gj-text max-width="120px">{{ row.warehouseName }}</gj-text>
            </div>
            <div class="marginRight40">
              <span class="label-color">备注：</span>
              <gj-text max-width="120px">{{ row.memo }}</gj-text>
            </div>
            <div class="marginRight40">
              <span class="label-color">总采购成本合计：</span>
              <span>{{ row.changeTotalPurchaseCost | amount |defaultShow(row.currencySymbol) }}</span>
            </div>
            <div class="marginRight40">
              <span
                  class="label-color">总到库成本合计：</span>{{ row.changeTotalArriveCost | amount | defaultShow(row.currencySymbol) }}
            </div>
            <div class="marginRight40">
              <span class="label-color">创建人：</span>
              {{ row.createUserName }}
            </div>
            <div class="marginRight40">
              <span class="label-color">创建时间：</span>
              {{ row.createTime }}
            </div>

          </div>
          <template v-else>
            <gj-image :src="row.skuImageUrl"></gj-image>
          </template>
        </template>
        <template v-slot:changeQuantity="{row}">
          <template v-if="row.$gjParentData">
            {{row.totalChangeQuantity | defaultShow}}
          </template>
          <template v-else>
            {{row.changeQuantity | defaultShow}}
          </template>
        </template>
        <template v-slot:changeBadQuantity="{row}">
          <template v-if="row.$gjParentData">
            {{row.totalChangeBadQuantity | defaultShow}}
          </template>
          <template v-else>
            {{row.changeBadQuantity | defaultShow}}
          </template>
        </template>
        <template v-slot:changePurchaseCost="{ row }">
          <div class="default" v-if="!row.$gjParentData">
            {{row.changePurchaseCost | amount | defaultShow(row.currencySymbol)}}
          </div>
        </template>
        <template v-slot:changeArriveCost="{ row }">
          <div class="default" v-if="!row.$gjParentData">
            {{row.changeArriveCost | amount | defaultShow(row.currencySymbol)}}
          </div>
        </template>
        <template v-slot:changeTotalPurchaseCost="{ row }">
          <div class="default" v-if="!row.$gjParentData">
            {{row.changeTotalPurchaseCost | amount | defaultShow(row.currencySymbol)}}
          </div>
        </template>
        <template v-slot:changeTotalArriveCost="{ row }">
          <div class="default" v-if="!row.$gjParentData">
            {{row.changeTotalArriveCost | amount | defaultShow(row.currencySymbol)}}
          </div>
        </template>
        <template v-slot:op="{ row }">
          <template v-if="row.$gjParentData">
            <gj-button type="text" @click="openDetail(row)">详情</gj-button>
          </template>
        </template>
        <template v-slot:extend:row="{row}">
          <div class="default" v-if="row.extendRow">
            <gj-link @click="openDetail(row)">共计{{row.num}}条数据，请查看详情>>></gj-link>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
  import {queryMixin} from "@/minxins";
  import AppInboundOutboundDetail from './modal/inbound-outbound-detail';
  import AppOtherInboundOutbound from './modal/other-inbound-outbound';
  import {documentTypeEnum, opTypeOption} from "./enum";
  import {getInboundPage} from "@/api/warehouse";
  import {convertToDate} from "@/utils/date.util";
  import {isMeaningful, transformToMap} from "@/utils/common";
  import {ProductEnum} from "@/utils/options";

  import viewConfig from './viewConfig'
  import { generateViewParams } from "@/utils/date.util";


  export default {
    name: "inbound-outbound",
    mixins: [queryMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'picture', header: '图片', field: 'slot:picture', minWidth: '50px'},
          {id: 'sku', header: 'SKU', field: 'sku', width: '160px'},
          {id: 'productName', header: '产品名称', field: 'productName', minWidth: '160px'},
          {id: 'productType', header: '产品类型', field: 'option:productType', minWidth: '100px', options: ProductEnum.typeOption},
          {id: 'categoryName', header: '品类', field: 'categoryName', minWidth: '140px'},
          {id: 'changePurchaseCost', header: '采购成本', field: 'slot:changePurchaseCost',prefix: "currencySymbol", width: '100px', align: 'right'},
          {id: 'changeArriveCost', header: '到库成本', field: 'slot:changeArriveCost',prefix: "currencySymbol", width: '100px', align: 'right'},
          {id: 'changeTotalPurchaseCost', header: '总采购成本', field: 'slot:changeTotalPurchaseCost',prefix: "currencySymbol", width: '100px', align: 'right'},
          {id: 'changeTotalArriveCost', header: '总到库成本', field: 'slot:changeTotalArriveCost',prefix: "currencySymbol", width: '100px', align: 'right'},
          {id: 'changeQuantity', header: '良品量', field: 'slot:changeQuantity', width: '100px', align: 'right'},
          {id: 'changeBadQuantity', header: '次品量', field: 'slot:changeBadQuantity', width: '100px', align: 'right'},
          {id: 'op', header: '操作', field: 'slot:op', width: '70px', fixed: 'right'},
        ],
        filter: {
          keyword: {
            key: 'code',
            value: null,
          },
          warehouseIds: null,
          type: null,
          createUser: null,
          date: null,
        },
        documentTypeEnum: documentTypeEnum,
        opTypeOption: opTypeOption,
        opTypeMap: transformToMap(opTypeOption),
        model: viewConfig,
        moduleName: 'INBOUND_OUTBOUND'
      }
    },
    methods: {
      generateViewParams,
      /**
       * 设置全局查询参数
       */
      mergeRemoteParams (params) {
        const date = params.date ? params.date : [params.startDateTime, params.endDateTime]
        this.filter = Object.assign({}, this.filter, {
          ...params,
          date
        })
      },
      $gjQuery() {
        this.loading = true;
        const params = {
          model: {
            warehouseIds: this.filter.warehouseIds,
            opType: this.filter.type,
            createUser: this.filter.createUser,
            startCreateTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[0]) : null,
            endCreateTime: isMeaningful(this.filter.date) ? convertToDate(this.filter.date[1]) : null,
          },
          ...this.querySort,
          ...this.queryPagination,
        };
        params.model[this.filter.keyword.key] = this.filter.keyword.value;
        this.globalParams = params;
        getInboundPage(params)
          .then((data) => {
            this.tableData = data.records;
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
      },
      $gjQueryInitParams() {
        return {
          filter: {
            keyword: {
              key: 'code',
              value: null,
            },
            warehouseIds: null,
            type: null,
            createUser: null,
            date: null,
          }
        }
      },
      openDetail(row) {
        this.$gjCreate(AppInboundOutboundDetail, {
          props: {
            item: row,
          }
        })
      },
      openInboundOutbound(type) {
        const modal = this.$gjCreate(AppOtherInboundOutbound, {
          props: {
            type: type,
            documentTypeEnum: this.documentTypeEnum,
          },
          on: {
            after: () => {
              this.$gjResetPage();
              modal.$gjDestroy();
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
.label-color {
  color: #999;
}
.marginRight40{
  margin-right: 40px;
}
</style>
